// Configuración del canal campus "Galletas de Sara" (brazolovers.com/udla).
//
// Fuente única de verdad para el FRONTEND del canal. Los datos operativos
// (WhatsApp, punto, hora) también existen como env en el backend; aquí viven
// como constantes para que la página funcione incluso si el API no responde
// (degradación elegante). El backend siempre manda en stock/estado/precio.

// ─────────────────────────────────────────────────────────────────────────────
// DATOS DE SARA  — TODO: completar antes de desplegar
// ─────────────────────────────────────────────────────────────────────────────
export const SARA = {
  // Número de WhatsApp de Sara (formato internacional SIN "+"). +593978707553.
  whatsapp: '593978707553',
  // Punto/hora son SOLO el fallback si el API no responde. El valor real lo
  // edita Sara desde /udla/admin (se guarda en Mongo) y llega por /api/campus/config.
  puntoEntrega: 'Coordinamos el punto por WhatsApp',
  horaEntrega: '12:30 – 13:30',
  diaEntrega: 'Viernes',
  // Cierre de pedidos (coincide con la lógica del backend: jueves 20:00)
  cierre: 'Jueves 8:00 pm',
};

export const PRECIO_UNITARIO = 1.0; // $1.00 fijo, sin excepciones

// ─────────────────────────────────────────────────────────────────────────────
// MÉTODOS DE PAGO — datos públicos que el comprador necesita para pagar.
// ─────────────────────────────────────────────────────────────────────────────
export const PAGO = {
  transferencia: {
    banco: 'Banco Guayaquil',
    tipoCuenta: 'Ahorros',
    numeroCuenta: '0058350529',
    titular: 'Sandoval Parra Sara Antonella',
    cedula: '1757881808',
    email: 'sasandovalpa@gmail.com',
  },
  // TODO: pegar aquí la imagen del QR de cobro de Sara (export/captura desde
  // su app De Una) en /public/images/udla/deuna-qr-sara.png. Mientras no
  // exista el archivo, la sección de pago muestra un aviso en su lugar.
  deunaQrImage: '/images/udla/deuna-qr-sara.png',
};

// Máximo de galletas por viernes (espejo de CAMPUS_STOCK_MAX del backend; solo
// para límites de UI — el stock real y su validación viven en el servidor).
export const STOCK_MAX = 120;

// ─────────────────────────────────────────────────────────────────────────────
// LOS 7 SABORES  — mismos assets (imágenes G0x) que el sitio principal.
// El `id` viaja al backend en cada ítem del pedido {galleta_id, name, qty}.
// ─────────────────────────────────────────────────────────────────────────────
export const CAMPUS_GALLETAS = [
  {
    id: 'choco_chips',
    name: 'Choco Chips',
    description: 'La clásica de mantequilla cargada de chispas de chocolate. La favorita de todos.',
    image: '/images/G01_Galleta_ChocoCookies.webp',
  },
  {
    id: 'choco_nuez',
    name: 'Choco Nuez',
    description: 'Chocolate intenso con nueces tostadas. Crujiente por fuera, suave por dentro.',
    image: '/images/G02_Galleta_Choco_Nuez.webp',
  },
  {
    id: 'red_velvet',
    name: 'Red Velvet',
    description: 'Terciopelo rojo con su toque de cacao y chispas blancas.',
    image: '/images/G03_Galleta_Red_Velvet.webp',
  },
  {
    id: 'canela',
    name: 'Canela',
    description: 'Suave, especiada y aromática. Como un abrazo de canela.',
    image: '/images/G04_Canela.webp',
  },
  {
    id: 'avena_arandanos',
    name: 'Avena con Arándanos',
    description: 'Avena con arándanos: la que finge ser saludable y igual te encanta.',
    image: '/images/G05_Galleta_Avena_Arandanos.webp',
  },
  {
    id: 'limon',
    name: 'Limón',
    description: 'Fresca y cítrica, con ese punto ácido que engancha.',
    image: '/images/G06_Galleta_Limon.webp',
  },
  {
    id: 'coco',
    name: 'Coco',
    description: 'Coco rallado en cada mordida. Tropical y adictiva.',
    image: '/images/G07_Galleta_Coco.webp',
  },
];

// Versión "sin fondo" (recorte real vía IA, no solo crop) de cada galleta —
// se usa en el header y en las tarjetas de /udla en vez de la foto con fondo
// negro de estudio del sitio principal (`image`, arriba). Generadas con
// rembg + recorte/optimización a webp; ver tools/udla_cutouts/gen_cutouts.py
// para el script si hace falta regenerarlas.
//
// CUTOUT_VERSION: el sitio corre detrás de Cloudflare, que cachea /images/*
// por URL exacta. Como estos archivos se sobreescriben con el MISMO nombre
// cada vez que se regeneran, sin esto el CDN sigue sirviendo bytes viejos
// indefinidamente aunque el deploy suba el archivo nuevo (nos pasó: el fix
// del plato/reflejo en Coco no se veía en prod hasta agregar esto). Súbele el
// número cada vez que regeneres las imágenes.
const CUTOUT_VERSION = 2;
export const cutoutImage = (id) => `/images/udla-cutout/${id}.webp?v=${CUTOUT_VERSION}`;

// Base URL del backend (mismo patrón que useProducts). '' = mismo origen.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// ─────────────────────────────────────────────────────────────────────────────
// COPY  — tono cercano, universitario, tuteo.
// ─────────────────────────────────────────────────────────────────────────────
export const COPY = {
  marca: 'Galletas de Sara',
  endoso: 'powered by Brazolovers',
  tagline: 'Artesanales, recién horneadas y a $1.',
  elegir: 'Elige tus sabores 🍪',
  cerrado:
    'Los pedidos de esta semana ya cerraron 😔 Vuelve el sábado para pedir las del próximo viernes.',
  ctaWhatsApp: 'Pedir por WhatsApp',
  ctaConfirmar: 'Confirmar por WhatsApp →',
  hoyTitulo: '🔥 Disponibles HOY',
  hoySubtitulo: 'Retiro inmediato, mientras dure el stock.',
};
